export const EXPORT_PARAMS_REQUEST = "EXPORT_PARAMS_REQUEST"
export const EXPORT_PARAMS_SUCCESS = "EXPORT_PARAMS_SUCCESS"
export const EXPORT_PARAMS_FAILURE = "EXPORT_PARAMS_FAILURE"
export const EXPORT_PARAMS_RESET = "EXPORT_PARAMS_RESET"

export interface ExportParamsRequest {
  type: typeof EXPORT_PARAMS_REQUEST
  payload: {
    code: string
  }
}

export interface ExportParamsSuccess {
  type: typeof EXPORT_PARAMS_SUCCESS
  payload: {
    data: any
    code: string
  }
}

export interface ExportParamsFailure {
  type: typeof EXPORT_PARAMS_FAILURE
  payload: {
    message: string
    code: string
  }
}

export interface ExportParamsReset {
  type: typeof EXPORT_PARAMS_RESET
}

export type AddonAction =
  | ExportParamsRequest
  | ExportParamsSuccess
  | ExportParamsFailure
  | ExportParamsReset

